import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { routerReducer, LOCATION_CHANGE } from 'react-router-redux';
import localStorage from 'redux-persist/lib/storage';
import networkStorage from '../store/networkStorage';
import buildings from './reducers/buildings';
import sites from './reducers/sites';
import favorites from './reducers/favorites';
import areas from './reducers/areasReducers';

const initialViewportInfo = { center: [41.5665849, -93.7465999], zoom: 4, level: undefined };

export function viewportInfo(state = initialViewportInfo, action) {
  switch (action.type) {
    case 'CAPTURE_VIEWPORT_INFO': {
      let level;
      if (action.viewport.zoom === 9) {
        level = 9; // Zip codes
      } else if (action.viewport.zoom === 10) {
        level = 5; // Tract
      } else if (action.viewport.zoom > 10) {
        level = 4; // Block group
      } else if (action.viewport.zoom === undefined) {
        level = 4;
      }
      return {
        ...state,
        ...action.viewport,
        level,
      };
    }
    default:
      return state;
  }
}

export function modal(state = null, action) {
  switch (action.type) {
    case 'ACTIVATE_MODAL':
      return action.name;
    case 'DEACTIVATE_MODAL':
      return null;
    default:
      return state;
  }
}

export function measure(state = false, action) {
  switch (action.type) {
    case 'ACTIVATE_MEASURE':
      return true;
    case 'DEACTIVATE_MEASURE':
      return false;
    default:
      return state;
  }
}

export function draw(state = '', action) {
  switch (action.type) {
    case 'SET_ACTIVE_DRAWING':
      return action.shape;
    default:
      return state;
  }
}

export function filterDisplay(state = '', { type, name, payload }) {
  switch (type) {
    case LOCATION_CHANGE:
      return payload.pathname === '/' || payload.pathname.indexOf(state) > -1 ? state : '';
    case 'OPEN_FILTER':
      return name;
    case 'CLOSE_FILTER':
      return '';
    case 'TOGGLE_FILTER':
      return state ? '' : name;
    default:
      return state;
  }
}

export function organizationId(state = '', { type, id }) {
  switch (type) {
    case 'SET_ORGANIZATION_ID':
      return id;
    default:
      return state;
  }
}

export function viewer(state = {}, { type, customizations, polygon }) {
  switch (type) {
    case 'ADD_VIEWER_CUSTOMIZATIONS':
      return {
        ...state,
        ...customizations,
      };
    case 'UPDATE_MAP_TYPE':
      return {
        ...state,
        mapType: customizations.mapType,
      };
    case 'SET_VIEWER_POLYGON':
      return {
        ...state,
        polygon,
      };
    default:
      return state;
  }
}

export function hoveredProperty(state = {}, { type, property }) {
  switch (type) {
    case 'ADD_HOVERED_PROPERTY':
      return property;
    case 'CLEAR_HOVERED_PROPERTY':
      return {};
    default:
      return state;
  }
}

export function saveSearchedItems(state = [], action) {
  switch (action.type) {
    case 'SAVE_SEARCHED': {
      return action.searchedItems;
    }
    default:
      return state;
  }
}

export function saveSearchedLayers(state = {}, action) {
  switch (action.type) {
    case 'SAVE_SEARCHED_LAYERS': {
      return action.layer;
    }
    default:
      return state;
  }
}

export function mapLoading(state = false, action) {
  switch (action.type) {
    case 'ACTIVATE_MAP_LOADING':
      return true;
    case 'DEACTIVATE_MAP_LOADING':
      return false;
    default:
      return state;
  }
}

export function listLoading(state = false, action) {
  switch (action.type) {
    case 'ACTIVATE_LIST_LOADING':
      return true;
    case 'DEACTIVATE_LIST_LOADING':
      return false;
    default:
      return state;
  }
}

// profile gets initialized at startup in index.js.
// We need this here to appease redux, and can fill it out later if needed.
export const profile = (state = {}) => state;

export default (orgId, authenticated) => {
  const persistConfig = {
    whitelist: ['folders', 'dontShow'],
    key: 'favorites',
    keyPrefix: `reduxPersist-${orgId}`,
    version: 1,
    storage: authenticated ? networkStorage : localStorage,
  };

  return combineReducers({
    organizationId,
    viewer,
    filterDisplay,
    modal,
    measure,
    draw,
    favorites: persistReducer(persistConfig, favorites),
    areas,
    buildings,
    sites,
    hoveredProperty,
    viewportInfo,
    router: routerReducer,
    profile,
    saveSearchedItems,
    saveSearchedLayers,
    mapLoading,
    listLoading,
  });
};



// WEBPACK FOOTER //
// ./src/store/reducers.js